var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ztixgdw9ia",
    d: "M0 0L9.145 0 9.145 16 0 16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -64.000000) translate(24.000000, 61.000000) translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ap7cu3zj0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ztixgdw9ia"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3E499F",
    d: "M8.206 0c.39.017.682.192.844.53.164.34.116.673-.145.953-.3.322-.619.63-.935.939-1.851 1.811-3.704 3.622-5.56 5.43-.113.11-.125.164-.003.283 1.51 1.467 3.012 2.94 4.516 4.413.64.627 1.29 1.247 1.917 1.886.513.522.327 1.29-.35 1.512-.41.135-.75.007-1.04-.275-.521-.509-1.04-1.02-1.562-1.529L1.68 10.03C1.239 9.6.81 9.157.357 8.738-.127 8.29-.11 7.706.35 7.261c1.687-1.632 3.36-3.279 5.037-4.92C6.06 1.682 6.73 1.022 7.401.363c.22-.216.47-.373.805-.364",
    mask: "url(#ap7cu3zj0b)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.9e2b7ac97d3dd676d9d7aba7e3fa88dd.svg";
export { ForwardRef as ReactComponent };